// «Сила N% от рекомендуемой» на карточке босса (баланс D1: владелец не мог пройти B03). Сервер присылает в
// GET /districts у точки босса `power {mine, recommended}` — Fd снимка игрока и эталона уровня босса; клиент силу
// не считает. Ниже 80% — предупреждение и что сделать: надеть лучшее, улучшить на Верстаке, раздать очки.
import { useApp } from '../app/app.js';
import { t as tr } from '../i18n/t.js';
import { districts, player } from '../state/game.js';
import { I } from '../assets/icons.js';
import '../ui/store.css';

export interface BossPower { mine: number; recommended: number }

/** Порог предупреждения: сила ниже 80% от эталона уровня босса. */
export const POWER_WARN = 0.8;

/** Сила точки босса из кэша карты; поле необязательное — нет его, блока нет. */
export function powerFor(bossId: string): BossPower | null {
  for (const d of districts.value?.data.districts ?? []) {
    const b = d.bosses.find((x) => x.bossId === bossId) as { power?: BossPower } | undefined;
    if (b?.power && b.power.recommended > 0) return b.power;
  }
  return null;
}

export function powerPct(p: BossPower): number {
  return Math.floor((p.mine / p.recommended) * 100); // вниз: 79,9% — это «79%», а не «80%» рядом с предупреждением
}

/** Предупреждение — по точному отношению, а не по округлённому проценту (79.9% — уже «тяжело»). */
export function powerLow(p: BossPower): boolean {
  return p.mine / p.recommended < POWER_WARN;
}

/** Блок силы в MOD-BOSS: процент, полоса и при < 80% — подсказки с переходами. */
export function PowerBlock(p: { bossId: string }) {
  const app = useApp();
  const pw = powerFor(p.bossId);
  if (!pw) return null;
  const pct = powerPct(pw);
  const low = powerLow(pw);
  const me = player.value;
  const cha = me ? me.stats.cha : 0;
  const go = (fn: () => void) => () => { app.nav.closeSheets(); fn(); };
  return (
    <div class={`card col power-block ${low ? 'low' : ''}`} style={{ gap: 6 }} data-testid="boss-power" data-low={low ? '1' : '0'}>
      <span class="row" style={{ justifyContent: 'space-between' }}>
        <b>{tr('CL-POWER-PCT', { n: pct })}</b>
        <span class={`small ${low ? 'neg' : 'pos'}`}>{low ? tr('CL-POWER-LOW') : tr('CL-POWER-OK')}</span>
      </span>
      <span class="progress power-bar"><i style={{ width: `${Math.min(100, pct)}%` }} /></span>
      {low ? (
        <div class="col" style={{ gap: 4 }} data-testid="power-tips">
          <span class="small">{tr('CL-POWER-TIPS')}</span>
          <button class="list-row power-tip" data-testid="power-wear" onClick={go(() => app.nav.push('SCR-INVENTORY'))}><I n="bag" size={20} /><span style={{ flex: 1 }}>{tr('CL-POWER-WEAR')}</span><span class="accent-text">›</span></button>
          <button class="list-row power-tip" data-testid="power-upgrade" onClick={go(() => app.nav.push('SCR-INVENTORY'))}><I n="wrench" size={20} /><span style={{ flex: 1 }}>{tr('CL-POWER-UPGRADE')}</span><span class="accent-text">›</span></button>
          <button class="list-row power-tip" data-testid="power-stats" onClick={() => app.nav.openSheet('MOD-STATS')}><I n="sparks" size={20} /><span style={{ flex: 1 }}>{me?.statPointsFree ? tr('CL-POWER-POINTS', { n: me.statPointsFree }) : tr('CL-POWER-STATS')}</span><span class="accent-text">›</span></button>
          {cha > 5 ? <span class="small muted" data-testid="power-cha">{tr('CL-POWER-CHA')}</span> : null}
        </div>
      ) : null}
    </div>
  );
}
